export default __webpack_public_path__ + "4f1ae63c0c74b9df2fa4990575d89f25.png";